export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;

export const API_KEY = '96f004c2-5c7d-4155-bbdb-2df8976b0820';

export const TIMEOUT_SEC = 10;

export const RES_PER_PAGE = 10;

export const MODAL_WINDOW_CLOSE_SEC = 2.5;
